import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PsychlngclCheckAngry from './pages/check/PsychlngclCheckAngry';
import PsychlngclCheckAngryResult from './pages/check/PsychlngclCheckAngryResult';
import PsychlngclCheckAnxiety from './pages/check/PsychlngclCheckAnxiety';
import PsychlngclCheckAnxietyResult from './pages/check/PsychlngclCheckAnxietyResult';
import PsychlngclCheckDepression from './pages/check/PsychlngclCheckDepression';
import PsychlngclCheckDepressionResult from './pages/check/PsychlngclCheckDepressionResult';
import PsychlngclCheckHappy from './pages/check/PsychlngclCheckHappy';
import PsychlngclCheckHappyResult from './pages/check/PsychlngclCheckHappyResult';
import PsychlngclCheckMain from './pages/check/PsychlngclCheckMain';
import PsychlngclCheckStreeResult from './pages/check/PsychlngclCheckStreeResult';
import PsychlngclCheckStress from './pages/check/PsychlngclCheckStress';
import PsychlngclCheckTraumatic from './pages/check/PsychlngclCheckTraumatic';
import PsychlngclCheckTraumaticResult from './pages/check/PsychlngclCheckTraumaticResult';
import ColumnDetail from './pages/column/ColumnDetail';
import ColumnList from './pages/column/ColumnList';
import NotFound from './pages/error/NotFound';
import HealingContents from './pages/healing/HealingContents';
import CounselMain from './pages/psychgclCounsel/CounselMain';
import Redirect from './pages/Redirect';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Redirect />} />
        <Route path="/column/columnList" element={<ColumnList />} />
        <Route path="/column/columnDetail/:strContentSeq" element={<ColumnDetail />} />
        <Route path="/psychlgclCheck/main" element={<PsychlngclCheckMain />}></Route>
        <Route path="/psychlgclCheck/stress" element={<PsychlngclCheckStress />}></Route>
        <Route path="/psychlgclCheck/stress/result/:resultCode" element={<PsychlngclCheckStreeResult />}></Route>
        <Route path="/psychlgclCheck/depression" element={<PsychlngclCheckDepression />}></Route>
        <Route path="/psychlgclCheck/depression/result/:resultCode" element={<PsychlngclCheckDepressionResult />}></Route>
        <Route path="/psychlgclCheck/anxiety" element={<PsychlngclCheckAnxiety />}></Route>
        <Route path="/psychlgclCheck/anxiety/result/:resultCode" element={<PsychlngclCheckAnxietyResult />}></Route>
        <Route path="/psychlgclCheck/angry" element={<PsychlngclCheckAngry />}></Route>
        <Route path="/psychlgclCheck/angry/result/:resultCode/:resultScore" element={<PsychlngclCheckAngryResult />}></Route>
        <Route path="/psychlgclCheck/traumatic" element={<PsychlngclCheckTraumatic />}></Route>
        <Route path="/psychlgclCheck/traumatic/result/:resultCode/:resultScore" element={<PsychlngclCheckTraumaticResult />}></Route>
        <Route path="/psychlgclCheck/happy" element={<PsychlngclCheckHappy />}></Route>
        <Route path="/psychlgclCheck/happy/result/:resultCode/:resultScore" element={<PsychlngclCheckHappyResult />}></Route>
        <Route path="/healingContent/main" element={<HealingContents />}></Route>
        <Route path="/psychgclCounsel/counselMain" element={<CounselMain />}></Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
